module.exports = __webpack_public_path__ + "templates/notFound.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/core/components/notFound/notFound.html
// module id = 353
// module chunks = 15